import { Box, BoxProps, Typography } from "@material-ui/core";
import { useThemeColor } from "@themes/Colors";
import React from "react";

export type PageTitleProps = BoxProps & {
}

export function PageTitle (props: PageTitleProps) {
    const themeColor = useThemeColor();

    return (
        <Box className={themeColor.component.pageTitle} {...props} />
    )
}

export type PageTitleTextProps = {
    text: string
}

export function PageTitleText ({text}: PageTitleTextProps) {
    return <Typography variant="h5"><strong>{text}</strong></Typography>;
}
